module.exports = __webpack_public_path__ + "static/GlitchlessSonyax54-cac69a5e3419e548962d908c730a1042.png";